import DiaryCharts from "@/features/charts/DiaryCharts";
import { diaryByIdQueryOptions } from "@/features/diaries/api";
import useExtractTracker from "@/features/entries/hooks/useExtractTracker";
import { trackerComponents as tc } from "@/features/trackers/components";
import { services as s } from "@/services";
import type { StatefulDiaryT } from "@/types/database/diaries";
import type { StatefulTrackerViewT } from "@/types/database/trackers";
import { createFileRoute } from "@tanstack/react-router";

export const TrackerPreview = () => {
	const { diaryId, trackerId } = Route.useParams();
	const { diary } = Route.useLoaderData();
	const tracker = useExtractTracker(diaryId, trackerId);

	return (
		<>
			<h1>{diary.diary_name}</h1>
			<h2>{tracker?.tracker_name}</h2>
			<p>{s.time.formatRange(tracker?.start_date, tracker?.end_date)}</p>
			<p>Tracker type: {tracker?.tracker_type}</p>

			<DiaryCharts diary={diary} />

			<tc.TrackerEntries tracker={tracker as StatefulTrackerViewT} />
		</>
	);
};
export const Route = createFileRoute(
	"/preview/patient/$patientId/diary/$diaryId/tracker/$trackerId/",
)({
	component: TrackerPreview,
	loader: async ({ context, params }) => {
		const diary = (await context?.queryClient.ensureQueryData(
			diaryByIdQueryOptions(params.diaryId),
		)) as StatefulDiaryT;
		return { diary };
	},
});
